export default class {
    constructor(target, time, callback) {
        this.stopped = false
        const finish = new Date(time);
        const s = 1000,
            m = s * 60,
            h = m * 60;

        const timer = function() {
            if (this.stopped) {
                target.innerHTML = '--:--';
                return
            }
            const now = new Date();
            const dist = finish - now;

            var minutes = Math.floor((dist % h) / m),
                seconds = Math.floor((dist % m) / s);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            target.innerHTML = minutes + ':' + seconds;

            if (dist > 0) {
                setTimeout(timer, 1000);
            } else {
                callback()
            }

        }.bind(this)

        timer()
    }

    stop() {
        this.stopped = true
    }
}
